import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import { getFbTrackingPayload } from "../../../utils/fbTracking";
import * as actions from "./actions";

function* fetchAvailability() {
  try {
    const result = yield call(AxiosCall, `/astralchart/get_availability/`);
    yield put(actions.astralAvailabilitySuccess(result.data.available));
  } catch (e) {
    yield put(actions.astralAvailabilityError(e));
  }
}

function* calculate(action) {
  try {
    const result = yield call(AxiosPost, `/astralchart/calculate/`, action.payload);
    const reading = result.data;
    if (reading.response === "ASTRAL_READING_CONSUMED") {
      throw new Error("Ya realizaste tu consulta diaria de Carta Astral");
    }
    if (!reading.id) {
      throw new Error("Error al calcular la carta astral");
    }
    yield put(actions.astralCalculateSuccess(reading));
  } catch (e) {
    yield put(actions.astralCalculateError(e));
  }
}

function* fetchPremiumReading(action) {
  try {
    const { reading_id, email } = action.payload;
    const params = new URLSearchParams({ reading_id });
    if (email) params.append('email', email);
    const result = yield call(AxiosCall, `/astralchart/get_premium_reading/?${params.toString()}`);
    if (result.data?.response === 'PENDING_REVIEW') {
      yield put(actions.astralPremiumPending(result.data.eta_at));
    } else {
      yield put(actions.astralPremiumSuccess(result.data));
    }
  } catch (e) {
    yield put(actions.astralPremiumError(e));
  }
}

function* createPendingAstral(action) {
  try {
    const result = yield call(AxiosPost, `/astralchart/create_pending_reading/`, action.payload);
    yield put(actions.createPendingAstralSuccess(
      result.data.reading_id,
      result.data.full_name,
    ));
  } catch (e) {
    yield put(actions.createPendingAstralFailure(e));
  }
}

function* createCheckout(action) {
  try {
    const result = yield call(AxiosPost, `/astralchart/create_checkout/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.astralCheckoutSuccess());
    window.location.href = result.data.checkout_url;
  } catch (e) {
    yield put(actions.astralCheckoutFailure(e));
  }
}

function* createPaypalOrder(action) {
  try {
    const result = yield call(AxiosPost, `/astralchart/create_paypal_order/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.astralPaypalOrderSuccess());
    window.location.href = result.data.approve_url;
  } catch (e) {
    yield put(actions.astralPaypalOrderFailure(e));
  }
}

function* verifyStripePurchase(action) {
  try {
    const result = yield call(AxiosPost, `/astralchart/verify_purchase/`, action.payload);
    yield put(actions.astralVerifyPurchaseSuccess(result.data));
  } catch (e) {
    yield put(actions.astralVerifyPurchaseFailure(e));
  }
}

function* verifyPaypalPurchase(action) {
  try {
    const result = yield call(AxiosPost, `/astralchart/verify_paypal_purchase/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.astralVerifyPaypalSuccess(result.data));
  } catch (e) {
    yield put(actions.astralVerifyPaypalFailure(e));
  }
}

function* fetchSynastry(action) {
  try {
    const result = yield call(AxiosPost, `/astralchart/get_synastry/`, action.payload);
    yield put(actions.astralSynastrySuccess(result.data));
  } catch (e) {
    yield put(actions.astralSynastryError(e));
  }
}

function* setReadingLike(action) {
  try {
    yield call(AxiosPost, `/astralchart/set_reading_like/`, action.payload);
    yield put(actions.astralLikeSuccess());
  } catch (e) {
    // silent fail for like
  }
}

function* calculateStandaloneSynastry(action) {
  try {
    const result = yield call(AxiosPost, `/astralchart/calculate_standalone_synastry/`, action.payload);
    const data = result.data;
    if (data.response === "ASTRAL_READING_CONSUMED") {
      throw new Error("Ya realizaste tu consulta diaria de compatibilidad");
    }
    yield put(actions.standaloneSynastrySuccess(data));
  } catch (e) {
    yield put(actions.standaloneSynastryError(e));
  }
}

function* fetchCatalog() {
  try {
    const result = yield call(AxiosCall, `/astralchart/get_catalog/`);
    const { results } = result.data;
    yield put(actions.astralCatalogSuccess(results));
  } catch (e) {
    yield put(actions.astralCatalogError(e));
  }
}

export default function* astralChartSaga() {
  yield all([
    takeLatest(actions.ASTRAL_AVAILABILITY_REQUEST, fetchAvailability),
    takeLatest(actions.ASTRAL_CALCULATE_REQUEST, calculate),
    takeLatest(actions.ASTRAL_PREMIUM_REQUEST, fetchPremiumReading),
    takeLatest(actions.ASTRAL_SYNASTRY_REQUEST, fetchSynastry),
    takeLatest(actions.ASTRAL_LIKE_REQUEST, setReadingLike),
    takeLatest(actions.ASTRAL_CATALOG_REQUEST, fetchCatalog),
    takeLatest(actions.STANDALONE_SYNASTRY_REQUEST, calculateStandaloneSynastry),
    takeLatest(actions.CREATE_PENDING_ASTRAL_REQUEST, createPendingAstral),
    takeLatest(actions.ASTRAL_CHECKOUT_REQUEST, createCheckout),
    takeLatest(actions.ASTRAL_PAYPAL_ORDER_REQUEST, createPaypalOrder),
    takeLatest(actions.ASTRAL_VERIFY_PURCHASE_REQUEST, verifyStripePurchase),
    takeLatest(actions.ASTRAL_VERIFY_PAYPAL_REQUEST, verifyPaypalPurchase),
  ]);
}
